"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBreadcrumb = void 0;
exports.defaultBreadcrumb = {
    breadcrumbList: [
        {
            name: 'HOME',
            link: 'https://devnew.okay.com/en-us',
            opened: false,
            hidden: false,
            action: '',
            page: 0,
            children: [],
        },
        {
            name: 'Insights',
            link: '/en-us/property-news/',
            opened: false,
            hidden: false,
            action: '',
            page: 0,
            children: [],
        },
        {
            name: 'In the News: Are Property Agencies Final...',
            link: '',
            opened: false,
            hidden: false,
            action: '',
            page: 0,
            children: [],
        },
    ],
    tFormat: {
        searchPage: 'Property for {0} in Hong Kong',
        homePage: 'Home',
        buy: 'Sale',
        rent: 'Rent',
    },
};
